<h3>{{ "i18n.base.two-factor-authentication.step-qrcode.header" | translate }}</h3>
<div class="form-group">
  <p>{{ (alternateDescription ?? "i18n.base.two-factor-authentication.step-qrcode.description") | translate }}</p>
</div>
<div class="qr-wrapper">
  <qrcode [qrdata]="qrData.qRCode" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
</div>
<div class="form-group mt-3">
  <label for="code">{{ "i18n.base.two-factor-authentication.step-qrcode.registration-code" | translate }}</label>
  <input id="code" type="password" class="form-control" placeholder="{{ 'i18n.base.login.password' | translate }}" [value]="qrData.code" appPasswordVisibility [disabled]="true">
</div>
<button class="btn btn-primary btn-right" (click)="onQrCodeRegistered()">
  {{ "i18n.shared.ok" | translate }}
</button>
